import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtrados'
})
export class FiltradosPipe implements PipeTransform {

  transform(value: any): any {
    const resultPost = [];
    for (const listado of value) {
      if (listado.idsolicitante.numeroconfirmacion !== null) {
         resultPost.push (listado);



  }

}
    return resultPost;
  }
}
